module.exports = __webpack_public_path__ + "img/5924ff4.jpg";